import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useBridgeAPI, useBridgeState } from '@digitaz/bridge-sdk-client';
import {
  normalizeWebsiteUrl,
  setLinkClass,
  ensureProtocolInWebsiteUrl,
  ensureHTTPProtocolInWebsiteUrl
} from '../../../utils/helpers';
import BaseContactBox from './BaseContactBox';

const ContactWebsiteBox = memo(({ value }) => {
  const { isWebView } = useBridgeState();
  const { openUrl } = useBridgeAPI();

  const normalizeValue = normalizeWebsiteUrl(value);
  const classNames = cn(
    'contact-box--website',
    setLinkClass(normalizeValue, 'contact-box--website')
  );

  const onClick = e => {
    if (isWebView) {
      e.preventDefault();
      openUrl(ensureHTTPProtocolInWebsiteUrl(value));
    }
  };

  return (
    <BaseContactBox
      linkHref={ensureProtocolInWebsiteUrl(value)}
      classNames={classNames}
      value={normalizeValue}
      onClickHandler={onClick}
      target="_blank"
      rel="noopener noreferrer nofollow"
    />
  );
});

ContactWebsiteBox.displayName = 'ContactWebsiteBox';

ContactWebsiteBox.propTypes = {
  value: PropTypes.string.isRequired
};

export default ContactWebsiteBox;
